import { useSelector } from "react-redux";

import ruby from "@/design/colors/ruby";
import trueBlue from "@/design/colors/trueBlue";

import {
  amber,
  blue,
  blueGrey,
  cyan,
  deepPurple,
  green,
  grey,
  lightGreen,
  lime,
  purple,
  red,
  teal,
} from "@mui/material/colors";

export default function useAccessibleColors() {
  const settings = useSelector((state) => state.settings);

  switch (settings.colorFilter) {
    case "protanopia":
      return {
        green: purple[500],
        lime: blue[500],
        amber: teal[500],
        red: amber[500],
        grey: grey[500],
      };
    case "tritanopia":
      return {
        green: trueBlue[500],
        lime: cyan[500],
        amber: amber[500],
        red: ruby[500],
        grey: grey[500],
      };
    case "achromatopsia":
      return {
        green: lightGreen[400],
        lime: cyan[500],
        amber: blue[500],
        red: deepPurple[500],
        grey: blueGrey[400],
      };
    default:
      return {
        green: green[500],
        lime: lime[500],
        amber: amber[500],
        red: red[500],
        grey: grey[500],
      };
  }
}
